/*
 * VDH — productpagina
 * Houdt de accordeons exclusief: er staat er hooguit één open.
 *
 * We zetten alleen het name-attribuut. Details-elementen met dezelfde naam
 * vormen in de browser een exclusieve groep: opent er één, dan sluit de browser
 * de andere zelf. Geen JavaScript dat meeluistert, dus ook niets dat in de weg
 * kan lopen van de collapsible-component van Broadcast.
 *
 * Een eerdere versie luisterde met een MutationObserver op het open-attribuut en
 * stuurde een click naar de andere triggers. Dat liep vast: het thema opende het
 * gesloten element opnieuw, waarna de observer weer afging — twee accordeons die
 * elkaar eindeloos openden en sloten.
 */
(function () {
  'use strict';

  var SELECTOR = '.product-vdh .product__block--accordion details';
  var GROUP = 'vdh-product-accordion';

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (details) {
      details.setAttribute('name', GROUP);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/*
 * Bezorgdag in de USP-regel
 *
 * Vervangt [bezorgdag] en [bezorgdatum] in de tekst van de productblokken door
 * de eerstvolgende werkdag waarop de bestelling binnen kan zijn.
 *
 * Waarom in de browser en niet in Liquid: Shopify cachet productpagina's, dus
 * een in Liquid berekende datum kan uren of dagen oud zijn tegen de tijd dat een
 * bezoeker hem ziet. Bovendien is 'now' in Liquid UTC, waardoor de grens van
 * 17:00 er in de zomer een uur naast zit.
 *
 * De klok van de bezoeker wordt niet gebruikt voor de dátum: die wordt via
 * Intl omgerekend naar Europe/Amsterdam, zodat iedereen dezelfde dag ziet.
 */
(function () {
  'use strict';

  var ZONE = 'Europe/Amsterdam';
  var TOKEN_DAY = '[bezorgdag]';
  var TOKEN_DATE = '[bezorgdatum]';
  var TOKEN_TIME = '[besteltijd]';

  function amsterdamNow() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hour12: false
    }).formatToParts(new Date()).reduce(function (acc, p) {
      acc[p.type] = p.value; return acc;
    }, {});

    // Middernacht van de Amsterdamse kalenderdag, als lokale Date zodat
    // getDay() en setDate() gewoon werken.
    return {
      date: new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day)),
      hour: Number(parts.hour) % 24
    };
  }

  function isWeekend(d) {
    return d.getDay() === 0 || d.getDay() === 6;
  }

  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) days--;
    }
    return d;
  }

  function deliveryDate(cutoffHour, workingDays) {
    var now = amsterdamNow();
    var shipDay = now.date;

    // Na de grens telt de bestelling als die van de volgende werkdag.
    if (now.hour >= cutoffHour) shipDay = addWorkingDays(shipDay, 1);

    // In het weekend bestellen betekent dat de verwerking maandag begint.
    while (isWeekend(shipDay)) shipDay.setDate(shipDay.getDate() + 1);

    return addWorkingDays(shipDay, workingDays);
  }

  function replaceTokens(root, values) {
    var tokens = Object.keys(values);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (text.indexOf('[') === -1) continue;

      for (var i = 0; i < tokens.length; i++) {
        text = text.split(tokens[i]).join(values[tokens[i]]);
      }
      if (text !== node.nodeValue) node.nodeValue = text;
    }
  }

  function init() {
    var section = document.querySelector('.product-vdh');
    if (!section) return;

    var host = section.querySelector('[data-vdh-delivery-cutoff]') || section;
    var cutoff = Number(host.getAttribute('data-vdh-delivery-cutoff')) || 17;
    var days = Number(host.getAttribute('data-vdh-delivery-days')) || 2;

    var result = deliveryDate(cutoff, days);
    var day = new Intl.DateTimeFormat('nl-NL', { weekday: 'long' }).format(result);
    var date = new Intl.DateTimeFormat('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' }).format(result);

    var values = {};
    values[TOKEN_DATE] = date;
    values[TOKEN_DAY] = day;
    values[TOKEN_TIME] = String(cutoff) + ':00';

    replaceTokens(section, values);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
